import {
    REPLACE_CATEGORIES,
    SET_CATEGORIES_PAGESIZE,
    SET_CATEGORIES_PAGENUMBER,
    SET_CATEGORIES_TEXTFILTER
} from './actions';

const initialState = {
    categories: [],
    filters: {
        textFilter: ""
    },
    pageSize: 20,
    pageNumber: 1,
    totalResults: 0,
    totalPage: 1,
}

const SetState = (state = initialState, action) => {
    switch (action.type) {
        case REPLACE_CATEGORIES:
            return {
                ...state,
                categories: action.categories,
                totalResults: action.totalResults,
                totalPage: action.totalPage,
            }
        case SET_CATEGORIES_PAGESIZE:
            return {
                ...state,
                pageSize: action.pageSize
            }
        case SET_CATEGORIES_TEXTFILTER:
            return {
                ...state,
                filters: { ...state.filters, textFilter: action.textFilter }
            }
        case SET_CATEGORIES_PAGENUMBER:
            return {
                ...state,
                pageNumber: action.pageNumber
            }
        default:
            return state;
    }
}

export default SetState;